import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, FileText, Flag, AlertTriangle } from "lucide-react";

export default function AgentDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/agent/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  if (!stats) return <div className="text-navy/60">Loading…</div>;

  const cards = [
    { i: Users, label: "Leads", value: stats.leads, tid: "agent-stat-leads" },
    { i: FileText, label: "Tax Records", value: stats.tax_records, tid: "agent-stat-tax-records" },
    { i: Flag, label: "Flags", value: stats.flags, tid: "agent-stat-flags" },
    { i: AlertTriangle, label: "High Urgency", value: stats.high_urgency_flags, tid: "agent-stat-high-urgency", accent: true },
  ];

  return (
    <div data-testid="agent-dashboard">
      <div className="eyebrow mb-2">Overview</div>
      <h1 className="aperture-h1 text-4xl mb-2">Dashboard.</h1>
      <p className="text-sm text-navy/60 mb-10">Live view of leads, tax records, and urgency flags across your book of business.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
        {cards.map((c) => (
          <div key={c.label} data-testid={c.tid}
            className={`bg-white p-6 rounded-sm border ${c.accent ? "border-gold" : ""}`}
            style={{ borderColor: c.accent ? "#C4A265" : "rgba(10,37,64,0.10)" }}>
            <div className="flex items-center justify-between">
              <div className="eyebrow">{c.label}</div>
              <c.i className={`w-4 h-4 ${c.accent ? "text-gold" : "text-navy/60"}`} strokeWidth={1.5} />
            </div>
            <div className={`font-serif text-3xl mt-3 ${c.accent ? "text-gold" : "text-navy"}`}>{c.value}</div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-white p-8 rounded-sm border" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <div className="eyebrow mb-3">Getting started</div>
        <h2 className="aperture-h2 text-2xl mb-4">This portal is a scaffold.</h2>
        <ul className="space-y-2 text-sm text-navy/70 list-disc list-inside">
          <li>Leads, Tax Records, and Flags are wired to their MongoDB collections.</li>
          <li>Read endpoints are live: <code className="text-xs bg-navy/5 px-1.5 py-0.5 rounded">GET /api/agent/leads · /agent/tax-records · /agent/flags</code>.</li>
          <li>Access is protected by <code className="text-xs bg-navy/5 px-1.5 py-0.5 rounded">require_role("agent")</code> — accepts <span className="text-gold">agent · admin · superadmin</span> role.</li>
          <li>Ready for you to add: intake forms, county scrapers, urgency scoring, workflow states.</li>
        </ul>
      </div>
    </div>
  );
}
